import request from '@/common/js/request'

//获取微信配置信息--跳转小程序、获取定位信息
export const openWxmini = (info) => {
    return request({
        method: 'post',
        // url: '/api/share/',
        url: '/api/wechat/sign/',
        data: info
    })
}

// 获取图片信息
export const getActivity = (openid,classify_id) => {
    return request({
        method: 'get',
        url: '/activity/?openid='+openid + "&classify_id=" +classify_id,
    })
}

// 将code传给后台
export const send_code = (code) => {
    return request({
        method: 'get',
        url: '/new_get_user_info/?code=' + code
    })
}

//点击统计
export const click_statistics = (num) => {
    return request({
        method: 'get',
        url: '/api/tongji/?num=' + num
    })
}